/* eslint-disable dot-notation */
/* eslint-disable prefer-destructuring */
import { Controller } from 'stimulus';
import { ajax } from 'jquery';
import ParamRedirect, {
  AddHoverHighlight,
  hideLoading,
  ParamUrl,
  showLoading,
  URIPush,
} from './param_redirect';

export default class FilterController extends Controller {
  static targets = ['form', 'near', 'clear', 'searchUrl'];

  connect() {
    this.timeout = null;
    this.formTarget.addEventListener('change', (_e) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.buildResults();
      }, 1000);
    });

    // The search page has no "clear filters" button today; without this
    // check Stimulus logs 'Missing target element "filter.clear"'.
    if (!this.hasClearTarget) return;
    this.clearTarget.addEventListener('click', (ev) => {
      ev.preventDefault();
      window.history.pushState(
        { clear_filters: true },
        'clear filters',
        'search-map'
      );
      this.resetForm(this.formTarget);
      this.buildResults();
      return false;
    });
  }

  formValue(form) {
    console.log('Varma');
    const data = new FormData(form);
    const keys = Array.from(new Set(data.keys()));
    console.log(keys);
    const formHash = {};
    keys.forEach((key) => {
      const val = data.getAll(key);
      if (val !== undefined && val !== null && val !== '') {
        formHash[key] = val.length > 1 ? val : val[0];
      }
      if (key === 'near' && val && val !== '') {
        this.nearTarget.value = null;
      }
    });

    console.log(formHash);
    if (formHash['specialty']) {
      const specialty = formHash['specialty'].split('_');
      formHash['specialty'] = specialty[0];
      if (specialty[1] !== undefined) {
        formHash['practice_style'] = specialty[1];
      }
    }

    const isPracticeStyle = document.querySelector(
      'input[name="practice_style"]:checked'
    );
    if (!isPracticeStyle && formHash['specialty'] == 'all') {
      formHash['practice_style'] = 'both';
    }

    return formHash;
  }

  resetForm(form) {
    const { elements } = form;
    form.reset();
    for (let i = 0; i < elements.length; i++) {
      const fieldType = elements[i].type.toLowerCase();
      switch (fieldType) {
        case 'text':
        case 'password':
        case 'textarea':
        case 'hidden':
          elements[i].value = '';
          break;

        case 'radio':
        case 'checkbox':
          if (elements[i].checked) {
            elements[i].checked = false;
          }
          break;

        case 'select-one':
        case 'select-multi':
          elements[i].selectedIndex = -1;
          break;

        default:
          break;
      }
    }
  }

  buildResults() {
    const searchUrl = this.data.get('searchUrl');
    document.querySelector('#search-side-bar').classList.add('hidden');
    const formValues = this.formValue(this.formTarget);
    this.getResults().then(
      (data) => {
        const container = document.querySelector('#result-container');
        const pagination = document.querySelector('#pagination-container');
        const searchResultsCount = document.querySelector(
          '#search_results_count'
        );
        const breadCrumbContainer = document.querySelector(
          '#bread_crumb_container'
        );

        if (!container) {
          return null;
        }
        container.innerHTML = data.results;
        pagination.innerHTML = data.pagination;
        // The pagination HTML is built by the .json request, so its links
        // point at /search-map.json. Point them back at the normal page so a
        // click (or opening in a new tab) shows results, not raw JSON.
        pagination.querySelectorAll('a[href]').forEach((a) => {
          a.setAttribute(
            'href',
            a.getAttribute('href').replace(/\.json(?=\?|#|$)/, '')
          );
        });
        if (data.total_records && searchResultsCount) {
          searchResultsCount.innerHTML = data.total_records;
        }
        // Keep the "Displaying items X-Y of Z" line in step with the new
        // results (e.g. after switching to 25/50/100 per page or filtering),
        // the same way pagination_controller does when changing pages.
        const pagyInfoContainer = document.querySelector('#pagy_info_container');
        if (data.pagy_info_json && pagyInfoContainer) {
          pagyInfoContainer.innerHTML = data.pagy_info_json;
        }
        breadCrumbContainer.innerHTML = data.bread_crumb_html;
        document.getElementById('searchTerm').value = data.speciality_name;
        document.getElementById('near-location').innerHTML = data.h1_title;

        window.scrollTo(0, 0);

        if (window.map_helpers !== undefined && window.map_helpers !== null) {
          window.map_helpers.renderPins(data.pins || []);
          // window.map_helpers.adjustZoomLevel(data.max_distance);
        }

        URIPush({
          changeParams: formValues,
          route: searchUrl,
          removeParams: ['page', ...this.removedFilters(formValues)],
        });

        hideLoading();
        AddHoverHighlight();
        // reset pagination using a controller
        return null;
      },
      (rej) => {
        hideLoading();
      }
    );
  }

  removedFilters(formValue) {
    // REMEMBER: make sure to change this when doctor filters are updated
    const allFields = [
      'specialty',
      'practice_style',
      'rating',
      'holistic_medicine',
      'experience',
      'telehealth',
      'life_style_medicine',
      'price',
      'is_specialized_search',
    ];
    const keys = Object.keys(formValue);

    return allFields.filter((a) => keys.indexOf(a) < 0);
  }

  getResults() {
    const searchUrl = this.data.get('searchUrl');
    showLoading();
    return ajax({
      url: ParamUrl({
        changeParams: this.formValue(this.formTarget),
        removeParams: ['page'],
        route: `${searchUrl}.json`,
      }),
    });
  }
}
